import React, {Component} from "react";
import {Container} from "reactstrap";
import SectionTitle from "../../components/Shared/SectionTitle";

//Import Icons
import Feature from "../../components/Shared/Feature";
import pen from "../../assets/images/icon/pen.svg";
import video from "../../assets/images/icon/video.svg";
import intellectual from "../../assets/images/icon/intellectual.svg";
import user from "../../assets/images/icon/user.svg";
import calendar from "../../assets/images/icon/calendar.svg";
import sandClock from "../../assets/images/icon/sand-clock.svg";

export default class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      features: [
        {
          id: 1,
          icon: 'uil uil-edit-alt h1 text-primary',
          imgUrl: pen,
          title: "Fully Licensed",
          description:
            "Approved by both the Serbian and Kenyan governments",
        },
        {
          id: 2,
          icon: 'uil uil-vector-square h1 text-primary',
          imgUrl: video,
          title: "Dedicated Focus",
          description:
            "Specializing exclusively in the Serbian labor market",
        },
        {
          id: 3,
          icon: 'uil uil-file-search-alt h1 text-primary',
          imgUrl: intellectual,
          title: "Supportive Team",
          description:
            "We guide you from application to arrival",
        },
        {
          id: 4,
          icon: 'uil uil-airplay h1 text-primary',
          imgUrl: user,
          title: "Transparent Process",
          description:
            "No hidden charges or false promises",
        },
        {
          id: 5,
          icon: 'uil uil-calendar-alt h1 text-primary',
          imgUrl: calendar,
          title: "Worker Welfare First",
          description:
            "We ensure your rights and safety are protected.",
        }
      ],
    };
  }
  render() {
    return (
      <React.Fragment>
          <Container className={""}>
            <SectionTitle
              title="Why Choose Diligent Staffing"
              desc="Because choosing the right partner makes all the difference—our commitment to excellence, personalized support, and proven results ensure you're always one step ahead."
            />
             <Feature featureArray={this.state.features} isCenter={true} />
          </Container>
      </React.Fragment>
    );
  }
}
